import { useEffect, useState } from 'react'

import { nextBusinessEvent, SEED_EVENTS } from './activityData'
import type { BusinessEvent } from './types'

const MAX_EVENTS = 80
const INTERVAL_MS = 6000

/**
 * Holds the company-activity feed and prepends a fresh (mock) business event on
 * an interval. The seam to a real source: swap the interval for a WebSocket /
 * polled domain-event stream — consumers (Activity tab, AI Insights) are agnostic.
 */
export const useBusinessActivity = (paused: boolean): BusinessEvent[] => {
  const [events, setEvents] = useState<BusinessEvent[]>(SEED_EVENTS)

  useEffect(() => {
    if (paused) return undefined
    const handle = window.setInterval(() => {
      setEvents((prev) => [nextBusinessEvent(), ...prev].slice(0, MAX_EVENTS))
    }, INTERVAL_MS)

    return () => window.clearInterval(handle)
  }, [paused])

  return events
}
